/**
 * 請求・収納API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 請求情報01Dto
 */
export interface Szme004aResponseClmtoClaimInfGetInfDtoClaimInf01Dto { 
    /**
     * まとめ請求区分コード：英数字<br>　コード変換マスタテーブルの「画面項目ID」\'C000600\'の「ユーザコード」を設定する
     */
    mtmclmDivcd: string;
    /**
     * まとめ請求区分コード名称：全半角混在
     */
    mtmclmDivAname: string;
    /**
     * 支払方法コード：英数字<br>　コード変換マスタテーブルの「画面項目ID」\'C000916\'の「ユーザコード」を設定する
     */
    payMethodDiv: string;
    /**
     * 支払方法コード名称：全半角混在
     */
    payMethodDivAname: string;
    /**
     * 請求書種類コード：英数字<br>　コード変換マスタテーブルの「画面項目ID」\'C000881\'の「ユーザコード」を設定する
     */
    billSyuruiCode: string;
    /**
     * 請求書種類コード名称：全半角混在
     */
    billSyuruiCodeAname: string;
    /**
     * 領収証種類コード：英数字<br>　コード変換マスタテーブルの「画面項目ID」\'C000892\'の「ユーザコード」を設定する
     */
    rcvsyoSyuruiDiv: string;
    /**
     * 領収証種類コード名称：全半角混在
     */
    rcvsyoSyuruiDivAname: string;
    /**
     * 請求契約メモテキスト：全角
     */
    rcptfxMemo?: string;
    /**
     * 請求契約メモ詳細テキスト：全角
     */
    rcptfxSyosai?: string;
}

